import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const FloatingVoiceButton = ({ status, onClick, disabled }) => {
  const avatarUrl = "https://customer-assets.emergentagent.com/job_realtime-lucy/artifacts/z441nohm_IMG_6197.jpeg";

  // Responsive positioning
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

  const getButtonStyle = () => {
    const baseStyle = {
      position: 'fixed',
      bottom: isMobile ? '80px' : '24px',
      right: isMobile ? '16px' : '24px',
      zIndex: 50
    };

    switch (status) {
      case 'connected':
        return {
          ...baseStyle,
          border: '4px solid var(--accent-mint)',
          boxShadow: '0 0 30px rgba(52, 211, 153, 0.6)'
        };
      case 'connecting':
        return {
          ...baseStyle,
          border: '4px solid var(--accent-ocean)',
          boxShadow: '0 0 30px rgba(56, 189, 248, 0.6)'
        };
      case 'error':
        return {
          ...baseStyle,
          border: '4px solid #ef4444',
          boxShadow: '0 0 30px rgba(239, 68, 68, 0.6)'
        };
      default:
        return {
          ...baseStyle,
          border: '4px solid var(--accent-cyan)',
          boxShadow: '0 0 20px rgba(6, 182, 212, 0.4)'
        };
    }
  };

  const style = getButtonStyle();

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled || status === 'connecting'}
      className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden transition-all"
      style={{
        ...style,
        cursor: disabled ? 'not-allowed' : 'pointer'
      }}
      whileHover={{ scale: disabled ? 1 : 1.1 }}
      whileTap={{ scale: disabled ? 1 : 0.95 }}
      animate={{
        scale: status === 'connected' ? [1, 1.05, 1] : 1
      }}
      transition={{
        duration: 1.5,
        repeat: status === 'connected' ? Infinity : 0
      }}
      data-testid="floating-voice-button"
    >
      {/* Lucy's photo */}
      <img
        src={avatarUrl}
        alt="Lucy"
        className="w-full h-full object-cover"
      />

      {/* Loading overlay */}
      {status === 'connecting' && (
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <Loader2 size={28} className="animate-spin text-white" />
        </div>
      )}

      {/* Status indicator */}
      <div
        className="absolute bottom-0.5 right-0.5 sm:bottom-1 sm:right-1 w-3 h-3 sm:w-4 sm:h-4 rounded-full border-2 border-white"
        style={{
          background: 
            status === 'connected' ? 'var(--accent-mint)' :
            status === 'connecting' ? 'var(--accent-ocean)' :
            status === 'error' ? '#ef4444' :
            'var(--text-muted)'
        }}
      />
    </motion.button>
  );
};

export default FloatingVoiceButton;
